var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 455.67 423.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1481.13,
    y: 1919.79,
    width: 1167.13,
    height: 1167.13,
    rx: 583.57,
    transform: "translate(-1135.6 1966.85) rotate(-40.97)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_15",
    x1: 2268.8,
    y1: 3146.95,
    x2: 338.66,
    y2: 49.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#213462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#213665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#21437e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#204d90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#20539b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20559e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#205299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#204b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#213e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213462"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fondos"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.22,
    y: 0.01,
    width: 1920.46,
    height: 3240.66,
    fill: "url(#Degradado_sin_nombre_15)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.43,
    y: 0.24,
    width: 315.3,
    height: 182.14,
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.32,
    cy: 122.74,
    r: 43.96,
    fill: "#e6eef6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.76,
    cy: 91.92,
    r: 14.07,
    fill: "#e6eef6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.88,
    y: 51.91,
    width: 147.41,
    height: 82.95,
    rx: 14.15,
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10,
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,126.06a5,5,0,1,0,0-10H174.45a5,5,0,1,0,0,10Z",
    fill: "#e6eef6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.89,126.06a5,5,0,1,0,0-10H225.33a5,5,0,1,0,0,10Z",
    fill: "#76a0d5"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(189.56 65.55)",
    fontSize: 7.92,
    fill: "#22569f",
    fontFamily: "AvertaDemoPE-Regular, Averta Demo PE"
  }, "Sec", /*#__PURE__*/React.createElement("tspan", {
    x: 13.09,
    y: 0,
    letterSpacing: "0em"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.92,
    y: 0
  }, "ion 1")), /*#__PURE__*/React.createElement("rect", {
    x: 149.65,
    y: 89.56,
    width: 112.22,
    height: 1.26,
    fill: "#5284c4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.65,
    y: 92.38,
    width: 112.22,
    height: 1.26,
    fill: "#5284c4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.65,
    y1: 85.53,
    x2: 261.88,
    y2: 85.53,
    fill: "none",
    stroke: "#f7cac0",
    strokeMiterlimit: 10,
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.65,
    y1: 104.32,
    x2: 261.88,
    y2: 104.32,
    fill: "none",
    stroke: "#f7cac0",
    strokeMiterlimit: 10,
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.65,
    y1: 79.16,
    x2: 149.65,
    y2: 84.18,
    fill: "none",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.65,
    y: 71.84,
    width: 112.22,
    height: 1.26,
    fill: "#5284c4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.65,
    y: 74.68,
    width: 112.22,
    height: 1.26,
    fill: "#5284c4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.44,
    cy: 53.43,
    r: 24,
    fill: "#e6eef6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.69,168.64a25.37,25.37,0,0,1,.4-7.33s2.46-3.95,12.67-3.08,11.13,5.19,11.58,13.29c.87,15.49-13.22,15.18-13.22,15.18-5.75,1.05-8.74-.78-10.28-2.75a7.88,7.88,0,0,1-1.61-4.82l0-3.4Z",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.42,119.29s-1.91-2.83-2.21-2.78-6.12,2.88-6.51,3.73-2.35,11.39-1.86,11,8.67,0,8.67,0l3.74-3.23Z",
    fill: "#f4dcdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.37,128.62c-.44.24-.85.54-1.28.79a3.31,3.31,0,0,1-1.43.5c-1.14.08-1.82-.84-1.29-1.79.66-1.19,2.13-1.45,3.5-2.26s2.77.43,2.1,1.73a10,10,0,0,1-3.75,3.52c-1.52,1-3,2.27-4.74,2.78-.87.25-1.84.36-2.72.59a2,2,0,0,0-.59.22,2.18,2.18,0,0,0-.35.33c-2.43,2.66-4.93,4.84-7.36,7.5L84,133.13c.82-.82,1.64-1.63,2.43-2.47A27.88,27.88,0,0,0,90,126.91a47.19,47.19,0,0,0,2.34-4.31",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3,122.6c.79-2.41,2.76-3.82,4.47-5.53a17.46,17.46,0,0,1,1.39-1.33,8.89,8.89,0,0,1,2.36-1l2.72-1c.6-.22,1.41-.32,1.67.44a1.42,1.42,0,0,1-.09,1,5.34,5.34,0,0,1-2.64,2.27l-1.36,1.41a2.55,2.55,0,0,0-.47,2.92,3.92,3.92,0,0,1-.23,4.16",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.78,76.74a.87.87,0,0,0-1.23.07l-38.59,43a.86.86,0,0,0,.06,1.23.93.93,0,0,0,.62.23.88.88,0,0,0,.61-.29l38.6-43A.87.87,0,0,0,139.78,76.74Z",
    fill: "#fff",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.5,122.53s2.49-1.69,3,.25-2.72,3.42-2.72,3.42l-3,1.79a1.59,1.59,0,0,1-1.55-.66c-.81-.9.74-3.11,2.23-3.88A13.48,13.48,0,0,1,106.5,122.53Z",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.53,119.67s2.6-2,3.4,0-2.67,3.77-2.67,3.77l-3.12,2.11a1.87,1.87,0,0,1-1.79-.56c-1-.86.52-3.28,2.1-4.21A17,17,0,0,1,105.53,119.67Z",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.69,117.15c1.22-.65,2.66-1.09,3.16.13.72,1.79-2.43,3.43-2.43,3.43l-2.83,1.91c-1.35.5-2.26-1.07-1.68-2.16a6.61,6.61,0,0,1,2.18-2.31A17.2,17.2,0,0,1,103.69,117.15Z",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.78,313.91s-1.55,7.64-1.07,12.95H86.46s-.6-8.76-13.47-8.67l-1.79-4.75",
    fill: "#010101",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,313.55s1.41,8.08,1,13.69H4.32s1.56-9.16,6.37-9.16l1.63-5",
    fill: "#010101",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "about-info-start-circuit",
    d: "M7.42,208.29C6.76,180.84,8.3,175,8.3,175l47.75-3.78c8,32,8.09,65.42,11.67,98.05l4.84,44.11L49.5,315.61l-17-105.08",
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.65,190.63v9.68l-2.64.22L32.49,316.06H8.3s-.22-80.32-.88-107.77",
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,117.8c-.78-2.51-3-13.16-3.29-15.77l1.48-11s-6.5-17.1-6.6-17-15,10-15,10L21.88,94a29.05,29.05,0,0,1,1.69,12.43L24.9,119Z",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.89,141.05l-13.7-21.94a25.13,25.13,0,0,0-9.83-9l-5.65-2.89-.29,2.43a57.08,57.08,0,0,0-.78,9.41,68.25,68.25,0,0,0-5.55-9.29s-4,1.06-4.26,1-6.26-4.26-6.26-4.26v-1.76l-1,1.26c-.93,1.22-3.65,3.75-10.92,8.73-13.11,9-11.66,15.62-11,26.37.44,6.88,1.47,16.46,2.16,22.45.4,3.49,1.76,6.14,4.86,7.79",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9,110a23.42,23.42,0,0,0-2.28,11.18A37.25,37.25,0,0,1,24.08,111a13.1,13.1,0,0,1-1.49-4.4,5.73,5.73,0,0,1,1.2-4.37s.73,4.53,10.3,7.51Z",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.26,118.72a29.56,29.56,0,0,0-2.45-9.46c-.12-.27-.29-.59-.59-.63-.47-.07-.72.53-.8,1-.14-1.59-.85-5.42-.85-5.42a5.23,5.23,0,0,1,2.71,2.12C44.93,109.7,44.5,114.68,44.26,118.72Z",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.36,145.5,62.76,160a8.05,8.05,0,0,0,5.62,2.82h0c2.24.16,4.44-.63,7.41-3.18l19-17.61L84.76,129.09,68.32,142.25",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,98.17c2.85,6.82,14.27,7.37,17.81,1,2.47-4.42.27-9.85-.22-14.49-.25-2.4-.16-4.88-.95-7.14,0,0-25.1,2.43-25.19,2.62s.39,7.66.39,7.66",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9,83.41a3.53,3.53,0,0,0,2,1.55,15.67,15.67,0,0,1,2.42.92,1.2,1.2,0,0,1,.68.83c0,.5-.46.85-.91,1.07A13.41,13.41,0,0,1,42.38,89",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.42,80a6.57,6.57,0,0,0,2-.75A2.79,2.79,0,0,0,44,74.67,7.29,7.29,0,0,0,42,73.45,41,41,0,0,0,31.1,70a10.68,10.68,0,0,0-5.52.56,15.23,15.23,0,0,0-4,2.91l-4.28,3.66c-1.28,1.1-2.63,2.3-2.88,4a10.62,10.62,0,0,0,.92,5.74,20.23,20.23,0,0,0,1.86,3.3,20,20,0,0,1,2.06,2.94,8.11,8.11,0,0,1,3-2.14,20,20,0,0,1,2.05-.57,1.59,1.59,0,0,0,1.27-1.71c-.39-3.84,1.17-7.53,5.43-8.39,2.28-.46,4.64-.11,7-.07A16,16,0,0,0,41.42,80Z",
    fill: "#1e1e1c",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,90.59a4.33,4.33,0,0,0-2.08-2.39,3.31,3.31,0,0,0-3.41,0,3.67,3.67,0,0,0-1.34,2,5.06,5.06,0,0,0,.35,4,4.2,4.2,0,0,0,3.31,2.15A3,3,0,0,0,24,94.83",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.79,84,31.15,85.1A1.38,1.38,0,0,0,30,86.35a1.3,1.3,0,0,0,.09.61c.57,1.38,1.94,3.08,5.27,2.66,3.49-.44,4.07-2.76,4-4.36A1.37,1.37,0,0,0,37.79,84Z",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.13,
    y1: 84.48,
    x2: 43.49,
    y2: 83.7,
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.8,
    cy: 86.38,
    r: 1.03,
    fill: "#1e1e1c",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.61,
    y1: 88.95,
    x2: 30.01,
    y2: 86.35,
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7,93.6a6.16,6.16,0,0,0,6-.21",
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29,166.56c1.63,3.61-1.68,8.47.81,11.55,1.28,1.59,3.55,1.88,5.59,2a205.22,205.22,0,0,0,38.15-.91c2.33-.27,4.86-.69,6.42-2.44,1.81-2,1.63-5.86.61-8.18a16.73,16.73,0,0,1-1.16-5.55c-.13-1.94-.32-3.89-.44-5.83-.13-2.12-1.89-23.6-1.89-25.71",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.25,
    y1: 135.79,
    x2: 20.24,
    y2: 152.4,
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.12,157.27l7.74-5.37a28.67,28.67,0,0,0,7.57-2.71,6.37,6.37,0,0,0,3.79-5.73s-.8-7-.8-7.34l-6.65,2.19s1.32-1.59,3-3.3c.64-.64.71-1.17.55-1.59a1.2,1.2,0,0,0-1.88-.45c-.68.53-2,1.55-4.6,3.45-5.23,3.82-5.1,6.43-5.1,6.43l-5.94,3.49",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.11,
    y1: 136.82,
    x2: 58.29,
    y2: 140.56,
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.68,138.33l10.46-5.82a1.45,1.45,0,0,1,1.82.63h0a1.71,1.71,0,0,1-.47,2.06l-7.06,4.6",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,151l23.58-10.21,2.82,17.53-27.9,12.83a10.67,10.67,0,0,1-8.78.11S5,170,4.15,167.92",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "225.07 185.84 225.07 198.06 242.12 198.06 242.12 179.81",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.29,191.21c-.08-.23-.28-3.64-.34-4.64a2,2,0,0,1,0-.55l.67-3.44a.68.68,0,0,1,.71-.55c.66.07,1.61.59,1.55,3.06V187l1,5.91",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.4,194c-.07-.24-.27-4-.31-4.77,0-.09,0-.19,0-.29l.58-3.51a.68.68,0,0,1,.89-.54c.52.21,1.09.9,1,3v1.91l.88,5.92",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.31,197.74c-.07-.27-.31-4.91-.31-4.91l.61-3.66a.66.66,0,0,1,.88-.53c.52.2,1.1.9,1.06,3v1.91l.88,5.92",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.19,191.39l-1.89-4-.18-2.32c-.16-2.51-.9-3.21-1.49-3.35a.67.67,0,0,0-.81.62l-.27,4.21a7.89,7.89,0,0,0,.08,1.68l.56,3.63a7.76,7.76,0,0,0,2.27,4.39l4.59,4.42a4.25,4.25,0,0,1,1.16,3.43l-1.49,13.09.37-1.41-.15,2.57h11v-5l-.33-13a6.94,6.94,0,0,0-2-4.63h0a7.61,7.61,0,0,0-1.38-1.09l-5.54-1.67",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.8,214.68c-3.92-5.24-15.69,2.08-15.69,2.08l-3,25.57a9.25,9.25,0,0,0,2.64,7.6h0a9.28,9.28,0,0,0,8.3,2.54l1.74-.34a9.2,9.2,0,0,0,5.68-3.59l1-1.4",
    fill: "#fff396",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.53,286l-21.08,1s-3.32,38.85-3,38.74,22-3.21,22-3.21Z",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.48,412.14s1.55,6.74,1.07,11.42H192.8s.6-7.72,13.47-7.64l1.79-4.19",
    fill: "#010101",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.33,411.49s-1.41,7.12-1,12.07H277s-1.56-8.08-6.37-8.08L269,411.06",
    fill: "#010101",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47,325.34c2.27,15.64,10.66,88.3,10.66,88.3l22.3-.45-9.8-153.58-52.35,5.45-2,148h22l12.89-122H248",
    fill: "#dbdbdb",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.7,258.77c3.4-1.6,5.74-5.94,7.65-9.17s3.6-6.67,6.27-9.31l-6.74-7.21L267.29,239a20.73,20.73,0,0,0-5.65,2.12",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,250.2l-3,5.1",
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.93,220c0-.19-.1,9.89-.17,18v.62c0,4.88-.08,8.81-.08,8.81l7.87,28.25-65.61,1.8,2.59-43.4-3.23-31.48a14.4,14.4,0,0,1,9-7.33l10.32-2.8h17.49l22,3.58,26.33,11a10.41,10.41,0,0,1,5.89,6.42h0a10.39,10.39,0,0,1-1.36,9.08l-16.35,23.57L264.9,235l9.74-12.7",
    fill: "#fff396",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "237.83 210.11 237.83 245.27 240.38 264.08",
    fill: "#fff396",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,190.77H225.82a3.88,3.88,0,0,0-3.06,1.73l-.5.68h22.23A4.15,4.15,0,0,0,241,190.77Z",
    fill: "#fff396",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.18,227.31l-15.66,21.23a9.2,9.2,0,0,1-5.68,3.59l-1.74.34a9.28,9.28,0,0,1-8.3-2.54h0a9.29,9.29,0,0,1-2.67-5.72,12.52,12.52,0,0,1,.68-2.69l7.13-8.8,15.85-31.11Z",
    fill: "#fff396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.18,227.31l-15.66,21.23a9.2,9.2,0,0,1-5.68,3.59l-1.74.34a9.28,9.28,0,0,1-8.3-2.54h0a9.25,9.25,0,0,1-2.64-7.6",
    fill: "#fff396",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "189.94 232.72 205.3 202.58 205.91 201.5",
    fill: "#fff396",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.19,198.22l-2.93-3-2.85-2.76s-2.1-1.31-1.25-2.74,2.73-.4,2.89-.28,4.22,2.81,4.22,2.81l4.84,1.79a7,7,0,0,1,1.17.56",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.93,220c0,.32,17.92,3.6,17.92,3.6",
    fill: "#fff",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.32,129.17c-.34.09-6.52,3.65-6.52,3.65l-7.74,8.72-5.7,4.54,1.87,2.91s10,4.68,10.42,4.35,7.58-5.36,7.58-5.36l-1.66-7.91,2.84-6.74.74-4.62Z",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.17,140.07s2.38,1.16.33,3.66l-3.77,1a1.43,1.43,0,0,1-1.68-1.66,1.72,1.72,0,0,1,.69-1.18",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.67,136.9l1.09,1.71v1.74L409,142.87a1.28,1.28,0,0,1-1.57-.45c-.55-.83-.83-2.16,1.62-3.27",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.82,134.56l1.94,1.25v1.7L409,140.72a1.32,1.32,0,0,1-1.94-1.36c.13-.66.73-1.52,2.26-2.58",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.45,130.7l-3.17,4.77a2.38,2.38,0,0,0,.36,3.05h0a.85.85,0,0,0,1.25-.09l3.51-4.32s2.19-3.29.61-4.14",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "417.15 128.15 418.49 140.35 434.06 138.73 433.11 126.32",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.27 200.35 400.27 263.38 442.28 249.82 448.46 206.82 400.27 200.35",
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.17,358.58s1.51,7.12,1,12.07H377.52s.58-8.16,13.07-8.08l1.74-4.43",
    fill: "#010101",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.22,358.37s-1.38,7.25-1,12.28h26.11s-1.53-8.22-6.24-8.22l-1.6-4.5",
    fill: "#010101",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.83,208.85,449,359.41H428.82s-8.75-93.29-8.88-93.71",
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "438.13 227.5 431.6 227.5 413.32 359.41 388.4 359.41 396.02 232.75 397.7 206.01",
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.26,128.1c-7.73,6-12.6,2.54-14.6,0s1.54-10.51,1.54-10.51a4.78,4.78,0,0,1-2.11-1.4,1.8,1.8,0,0,1,.34-2.55l3.73-2.82a3.64,3.64,0,0,0,1.13-1.42l2.08-4.63a13.85,13.85,0,0,1,16.07-1.24c8.89,5.25,9.82,7.42,9.82,7.42l-4.2,16.84",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.7,
    y: 110.26,
    width: 8.6,
    height: 5.99,
    rx: 2.32,
    transform: "translate(13.75 -41.73) rotate(5.87)",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.34,
    y1: 114.32,
    x2: 424.66,
    y2: 118.21,
    fill: "#010101",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.82,105.06a3.13,3.13,0,0,0-.42,2.43c.23,1,1.32,1.09,2.11.83a7.85,7.85,0,0,0,1.68-.92,9,9,0,0,1,2.79-1.26c4.89-1.15,5.82,4.23,4.86,7.79a5,5,0,0,0-.24,1.42c0,.91.62,1.28,1.37,1.63,1.45.67,2.93,1.9,2.83,3.49-.08,1.24-1.09,2.19-1.65,3.3-1.85,3.64,1.37,7.1,4.72,8,1.69.48,5.21,1.11,6.72,0a6,6,0,0,0,1.37-1.66c3-4.64,6.3-9.59,6.31-15.3,0-1.89,0-4-1.08-5.59s-3.14-2.56-4.81-3.68-2.7-2.57-4.19-3.7a15.56,15.56,0,0,0-11.71-2.58C415.73,99.84,410.83,101.6,408.82,105.06Z",
    fill: "#010101",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.87,118a3,3,0,0,1,3-1.78c2.81,0,3,4.24,1.73,6.11-1.93,2.77-4.33,1.56-4.33,1.56",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.21,108.61a3.48,3.48,0,0,1,1.53-.25,6.08,6.08,0,0,1,4,1.64",
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.57,
    y1: 110.79,
    x2: 409.73,
    y2: 110.28,
    fill: "#010101",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.46,121.29l2.24-2.65",
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.32,
    cy: 112.83,
    r: 1.09,
    fill: "#010101",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.32,120.39a4.35,4.35,0,0,0,3.93.66",
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.44,176.8l-13.75,9.61a7.38,7.38,0,0,1-7.9-2.31l-2.44-6.2.61-6.33L388.86,151l2.31-4.25,9,5.85",
    fill: "#fff",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.87,146l3-3.89a2.43,2.43,0,0,0,.31-.54l1.21-2.87a18.67,18.67,0,0,1,3.34-5.28l1.21-1.34a18.49,18.49,0,0,0,1.75-2.29,23.9,23.9,0,0,0,1.25-2l1-2.84a.89.89,0,0,1,1.26-.49c.63.37,1.26,1.34.92,3.82-.6,4.5-1.46,5.06-1.46,5.06s.86,2-.85,6.49",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.44,150.65s-6.69-1.24-4.8-6.79c-1.93-.47-2.62.3-4.57,2.9a4.94,4.94,0,0,0-.61,5.47",
    fill: "#fff",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.83,169.44a126.46,126.46,0,0,1,16.62-20.05,17.55,17.55,0,0,1,7.84-4.5c6-1.6,16.14-4.26,16.61-4.11,1.67.54,4.21.07,5.94.11,3.31.07,9.17,1.74,13.9,3.28a11.29,11.29,0,0,1,7.78,10.37c.19,5.82.2,13.57-.77,18.33-1.54,7.58-3.46,15.12-4.11,22.84a55.13,55.13,0,0,0-.23,5.89c0,2,.54,2.43,1.54,4.11.89,1.47,1.6,3.4.89,5.07l-52.47-1.09a12.16,12.16,0,0,1,1.9-6.3s1.64-26.06,1.37-26.37",
    fill: "#fff",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.74,142.44l-1.86-3c1.65-1.65,0-3.81,0-3.81H416.09s-1.49,3,.64,3.81v3.18",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.12,
    y1: 177.02,
    x2: 402.21,
    y2: 174.68,
    fill: "#fff",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.08,
    cy: 169.23,
    rx: 2.74,
    ry: 1.58,
    transform: "translate(-14.6 20.91) rotate(-5.26)",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.5,
    cy: 169.44,
    r: 1.13,
    fill: "#010101",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.56,177.51a4,4,0,0,0,4.76-1.41",
    fill: "#f4dcdc",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.81,165.74a4.17,4.17,0,0,1,4.84.34",
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.21,175.73c-2.11,0-3.06-.92-3.5-1.76a1.56,1.56,0,0,1,.52-2l2.8-2a1.6,1.6,0,0,0,.66-1.36l1.08,2.42Z",
    fill: "#f4dcdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.69,168.64A1.6,1.6,0,0,1,215,170l-2.8,2a1.56,1.56,0,0,0-.52,2c.44.84,1.39,1.76,3.5,1.76h.33",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.74,176.33a16.36,16.36,0,0,1-2.59,5.12,8.24,8.24,0,0,1-8.48,2.8,6.07,6.07,0,0,1-3.07-1.52c-1.8-1.79-1.72-4.55-2.46-6.82-.27-.82-.1-1.93-.89-2.3-.44-1.28-.9-2.11-2.22-2.08a.76.76,0,0,1-.79-.89c.56-2.84-.54-8.64-4.31-9.19a4,4,0,0,0-2.41.44c-.7.35-1.3.87-2,1.19a2.16,2.16,0,0,1-2.21-.1c-1.8-1.48.67-4.35,1.74-5.42a15.17,15.17,0,0,1,6-3.64c6.57-2.16,17.53-1.78,22.27,4.06,3.71,4.57,3.15,12,1.7,17.3C246,175.63,245.85,176,245.74,176.33Z",
    fill: "#010101",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.76,171.73a3.11,3.11,0,0,1,3.1-1.84c2.92,0,3.15,4.4,1.8,6.34-2,2.88-4.5,1.62-4.5,1.62",
    fill: "#f4dcdc",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.6,175.63l2-3",
    fill: "#f4dcdc",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.26,13.05H85.2v1H82.26v2.19a1.41,1.41,0,0,0,.18.78.71.71,0,0,0,.63.28.72.72,0,0,0,.62-.27,1.31,1.31,0,0,0,.2-.77V14.87H85.2v1.51a2.45,2.45,0,0,1-.13.81A1.84,1.84,0,0,1,84,18.34a2.53,2.53,0,0,1-1,.17,2.68,2.68,0,0,1-1-.17,2,2,0,0,1-.68-.47,1.82,1.82,0,0,1-.38-.68,2.76,2.76,0,0,1-.12-.82V11.61h1.39Z",
    fill: "#76a0d5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.68 13.05 90.87 16.47 90.03 13.05 88.61 13.05 87.87 16.47 87 13.05 85.52 13.05 87.04 18.37 88.48 18.37 89.32 15.28 90.16 18.37 91.6 18.37 93.13 13.05 91.68 13.05",
    fill: "#76a0d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,16.48a.73.73,0,0,1-.21.51,1.13,1.13,0,0,1-.54.32,1.07,1.07,0,0,1-.91-.11,1.52,1.52,0,0,1-.6-.83l3.53-1A3.83,3.83,0,0,0,97,13.24a2.23,2.23,0,0,0-2-.24,2.82,2.82,0,0,0-1,.48,2.12,2.12,0,0,0-.62.75,2.35,2.35,0,0,0-.25,1,3.44,3.44,0,0,0,.14,1.12q.8,2.79,3.36,2.05a2.37,2.37,0,0,0,1.29-.83,2.3,2.3,0,0,0,.48-1.45Zm-2.36-1.9a1,1,0,0,1,.62-.5,1.33,1.33,0,0,1,.4,0,1,1,0,0,1,.73.4,1.43,1.43,0,0,1,.24.46l-2.09.6A1.28,1.28,0,0,1,94.59,14.58Z",
    fill: "#76a0d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.22,14.11a1.57,1.57,0,0,0-.39-.66,1.7,1.7,0,0,0-.7-.4,3.35,3.35,0,0,0-1.07-.14A3.8,3.8,0,0,0,100,13a1.91,1.91,0,0,0-.72.39,1.41,1.41,0,0,0-.4.59,2.28,2.28,0,0,0-.13.76H100a1,1,0,0,1,.26-.57A.92.92,0,0,1,101,14a1.23,1.23,0,0,1,.65.15.43.43,0,0,1,.25.4.45.45,0,0,1-.19.41,1.91,1.91,0,0,1-.71.2c-.35,0-.68.1-1,.16a2.58,2.58,0,0,0-.77.29,1.33,1.33,0,0,0-.51.54,1.81,1.81,0,0,0-.19.91A1.42,1.42,0,0,0,99,18.11a1.91,1.91,0,0,0,1.35.4,2.34,2.34,0,0,0,1-.17,1.76,1.76,0,0,0,.66-.45,1.64,1.64,0,0,0,.09.48h1.31V15A3.11,3.11,0,0,0,103.22,14.11Zm-1.3,2.24a1.14,1.14,0,0,1-.1.45,1.23,1.23,0,0,1-.68.61,1.35,1.35,0,0,1-.5.1c-.45,0-.68-.2-.68-.6a.65.65,0,0,1,.23-.53,2.07,2.07,0,0,1,.83-.3c.26,0,.46-.1.6-.14a.77.77,0,0,0,.31-.18Z",
    fill: "#76a0d5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107 13.05 105.25 15.07 105.25 11.1 103.83 11.1 103.83 18.37 105.25 18.37 105.25 16.68 105.93 15.98 107.1 18.37 108.68 18.37 106.93 15.01 108.72 13.05 107 13.05",
    fill: "#76a0d5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.48 9.69 109.33 9.69 109.33 11.2 107.82 11.2 107.82 12.36 109.33 12.36 109.33 13.88 110.48 13.88 110.48 12.36 112 12.36 112 11.2 110.48 11.2 110.48 9.69",
    fill: "#76a0d5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.29,
    y1: 15.85,
    x2: 264.04,
    y2: 15.85,
    fill: "none",
    stroke: "#5284c4",
    strokeMiterlimit: 10,
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.29,
    y1: 13.61,
    x2: 325.29,
    y2: 17.65,
    fill: "none",
    stroke: "#5284c4",
    strokeMiterlimit: 10,
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.04,
    y1: 13.61,
    x2: 264.04,
    y2: 17.65,
    fill: "none",
    stroke: "#5284c4",
    strokeMiterlimit: 10,
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.06 11.93 277.47 14.62 275.89 11.93 279.06 11.93",
    fill: "#f7cac0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.a7e3e326.svg";
export { ForwardRef as ReactComponent };